'use client'

import { CheckMark } from '@qr-front/icons/checkmark'
import * as CheckboxPrimitive from '@radix-ui/react-checkbox'
import * as React from 'react'

import { cn } from '@/utils'

export const CheckboxVisual = ({
	disabled,
	className,
	checked,
}: {
	disabled?: boolean
	className?: string
	checked: boolean
}) => {
	return (
		<div
			className={cn(
				'relative size-6 shrink-0 rounded-6 bg-white ring-1 ring-inset ring-border-grey transition',
				disabled && 'cursor-not-allowed opacity-50',
				checked && 'bg-blue ring-blue',
				'[&:hover:not([disabled])]:ring-2',
				className,
			)}
		>
			<div
				className={cn(
					'absolute inset-0 flex items-center justify-center text-white transition-all duration-75',
					checked ? 'scale-100 opacity-100' : 'scale-95 opacity-0',
				)}
			>
				<CheckMark />
			</div>
		</div>
	)
}

export const Checkbox = React.forwardRef<
	React.ElementRef<typeof CheckboxPrimitive.Root>,
	React.ComponentPropsWithoutRef<typeof CheckboxPrimitive.Root> & {
		label?: string
	}
>(({ id, label, className, ...props }, ref) => (
	<div
		className={cn(
			'type-body-small flex items-center gap-2',
			className,
			props.disabled && 'text-grey',
		)}
	>
		<CheckboxPrimitive.Root
			ref={ref}
			id={id}
			className="data-[state=checked]:bg-primary size-6 shrink-0 rounded-6 bg-white ring-1 ring-inset ring-border-grey transition focus-visible:outline-none disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:bg-blue data-[state=checked]:ring-blue [&:hover:not([disabled])]:ring-2"
			{...props}
		>
			<CheckboxPrimitive.Indicator
				forceMount
				className={cn(
					'flex items-center justify-center text-white transition-opacity duration-75 data-[state=checked]:opacity-100 data-[state=unchecked]:opacity-0',
				)}
			>
				<CheckMark />
			</CheckboxPrimitive.Indicator>
		</CheckboxPrimitive.Root>
		{label ? <label htmlFor={id}>{label}</label> : null}
	</div>
))
Checkbox.displayName = CheckboxPrimitive.Root.displayName
